<style lang="stylus">
    .pcview-collect-container
        display flex
        flex-direction column
        position relative
        height 100%
        padding 0 0 0 24px
        user-select none
        &::-webkit-scrollbar
            width 6px
            pointer-events none
            background none
        &::-webkit-scrollbar-thumb
            background #D2D3D6
            border-radius 4px
        &::-webkit-scrollbar-track
            page_background()
        &::-webkit-scrollbar-track-piece
            background none
        &::-webkit-scrollbar-corner
            background none
        &.dark-theme__workbench
            &::-webkit-scrollbar-thumb
                background #484849
            &::-webkit-scrollbar-track
                background #1e1e20
            span
                color #222
        .filter-box
            top 30px
        .collect-box
            position relative
</style>

<template>
    <div class="pcview-collect-container" :class="{ 'dark-theme_pcview__files': isPCDarkMode == 2, 'dialog-view': isDialog }">
        <div class="filter-box" v-if="false">
            <div class="search-box">
                <input
                    autocomplete="off"
                    spellcheck="false"
                    type="text"
                    v-model="searchValue"
                    :placeholder="$t('search')"
                    @keypress="enter($event)"
                />
                <button class="search-icon" @click="search()">
                    <iconSymbol :name="'fileSearchIcon'" />
                </button>
            </div>
            <div class="order-box" v-if="!searchMode">
                <div>
                    <Dropdown trigger="click" @on-click="setOrder">
                        <a href="javascript:void(0)">
                            {{ $t(orderName) }}
                        </a>
                        <DropdownMenu slot="list">
                            <DropdownItem name="name">{{ $t("name") }}</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
                <iconSymbol :name="'orderIcon'" :style="{ transform: 'rotate(' + (rotate + 180) + 'deg)' }" @click.native="order()"></iconSymbol>
            </div>
        </div>

        <FileNum v-if="isPC" />

        <div class="pcview-files-scroll">
            <div class="collect-box">
                <tplWaterfall ref="waterfall" :works="works" type="collection" @cancelCollect="cancelCollect" />
            </div>
            <div class="emptyCloud" v-cloak v-if="userInfo && !pcNoLogin && showNoCollectTips">
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
            </div>
            <pclogin />
        </div>
    </div>
</template>

<script lang="ts">
    import naturalsort from "javascript-natural-sort";
    naturalsort.insensitive = true;

    import tplCenter from "@/home/mixins/tplCenter";
    import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
    import pclogin from "@/home/parts/pclogin.vue";
    import FileNum from "./parts/fileNum.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            pclogin,
            FileNum,
        },
    })
    export default class Base extends Mixins(tplCenter) {
        searchValue = "";
        searchList = [];
        rotate = parseInt(localStorage.getItem("max_order")) || 0;
        orderName = "name";
        list = [];
        selectItem = {
            class_id: "",
            sub_class_id: "",
        };
        showNoCollectTips = false;
        get searchMode() {
            return this.$store.state.collect.searchMode;
        }
        set searchMode(v) {
            this.$store.commit("setCollectStatus", {
                searchMode: v,
            });
        }
        wbHeaderEvent(obj) {
            let instance = this;
            let func = instance && obj.func_name ? instance[obj.func_name] : null;
            func && func(obj.args);
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get baseUrl() {
            return window["GLOBAL"].PUBLIC_OSS_HOST;
        }
        get pcNoLogin() {
            return this.isPC && !this.params.islogin;
        }
        toPCLogin() {
            (<any>window).$qt.jsCallUserLogin();
        }

        @Watch("userInfo.islogin")
        onLoginChanged(val, oldval) {
            if (this.isPC) {
                if (val && !oldval) {
                    this.init();
                    this.$bus.$emit("pcLoginEvenvt");
                } else if (!val && oldval) {
                    this.clearWaterfall();
                }
            }
        }
        getWorks() {
            this.$emit("setLoading", true);
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let para = JSON.parse(JSON.stringify(this.params));
            this.$edApi
                .getLikeAndCollectWorks(Object.assign(para, { type: "collect" }))
                .then((data) => {
                    this.clearWaterfall();

                    data = data.filter((item) => {
                        return item.url != null;
                    });
                    let collectIds = this.$store.state.tplCenter.collectIds;
                    data.forEach((item) => {
                        if (!collectIds.includes(item.id)) {
                            this.$store.commit("collect", item.id);
                        }
                    });
                    this.list = data;
                    if (data.length == 0) {
                        this.showNoCollectTips = true;
                        this.$emit("setLoading", false);
                    }

                    data = data.sort((a, b) => {
                        return this.rotate ? naturalsort(a["title"], b["title"]) : naturalsort(b["title"], a["title"]);
                    });

                    this.updateWaterfall({
                        works: data,
                        noCache: null,
                        callback: () => {
                            setTimeout(() => {
                                this.$emit("setLoading", false);
                            }, 450);
                        },
                    });
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                })
                .catch(() => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }
        cancelCollect(id) {
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].id == id) {
                    this.list.splice(i, 1);
                    break;
                }
            }
            this.$emit("setLoading", true);
            this.clearWaterfall();
            this.updateWaterfall({
                works: this.list,
                noCache: null,
                callback: () => {
                    setTimeout(() => {
                        this.$emit("setLoading", false);
                    }, 450);
                },
            });
        }
        init() {
            if (!this.params.islogin) {
                return;
            }
            this.getWorks();
            //获取已购买的作品
            this.$store.dispatch("getBoughtWorks");
        }

        enter(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        }

        search() {
            this.$emit("setLoading", true);
            if (this.searchValue) {
                this.$track("collect", "search");
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.searchValue = this.searchValue.trim();
                this.searchList = this.list.filter((item) => {
                    return item.title.toLowerCase().includes(this.searchValue.toLowerCase());
                });

                this.$store.commit("setState", { data: false, type: "showLoading" });
                if (this.searchList.length == 0) {
                    (<any>this).$edMessage.error(this.$t("notFind"));
                    this.$emit("setLoading", false);
                }
                this.clearWaterfall();
                this.updateWaterfall({
                    works: this.searchList,
                    noCache: null,
                    callback: () => {
                        setTimeout(() => {
                            this.$emit("setLoading", false);
                        }, 450);
                    },
                });
            } else {
                this.searchMode = false;
                this.clearWaterfall();
                this.updateWaterfall({
                    works: this.list,
                    noCache: null,
                    callback: () => {
                        setTimeout(() => {
                            this.$emit("setLoading", false);
                        }, 450);
                    },
                });
            }
        }
        setOrder(name) {
            this.orderName = name;
            this.$track("collect", "order");
            if (name === "name") {
                this.reOrder("title", this.rotate);
                // if (this.rotate == 0) {

                //     this.list = this.list.sort((a, b) => naturalsort(a.title, b.title))
                // } else {
                //     this.list = this.list.sort((a, b) => naturalsort(b.title, a.title))
                // }
            }
        }
        searchBack() {
            this.$emit("setLoading", true);
            this.searchMode = false;
            this.searchValue = "";
            this.clearWaterfall();
            this.updateWaterfall({
                works: this.list,
                noCache: null,
                callback: () => {
                    setTimeout(() => {
                        this.$emit("setLoading", false);
                    }, 450);
                },
            });
        }
        order() {
            if (this.rotate == 0) {
                this.rotate = 180;
                if (this.orderName == "name") {
                    this.reOrder("title", this.rotate);
                }
            } else {
                this.rotate = 0;
                if (this.orderName == "name") {
                    this.reOrder("title", this.rotate);
                }
            }
            localStorage.setItem("max_order", this.rotate.toString());
        }

        created() {
            console.log("data");
            this.$store.commit("setState", { data: 4, type: "selectId" });
            // this.$spin.hide();
            this.$bus.$on("updateWorkIds2", (payload) => {
                let { id, type } = payload;
                for (let i = 0; i < this.works.length; i++) {
                    if (this.works[i].id == id) {
                        switch (type) {
                            case "like": {
                                this.works[i].like = this.works[i].like - 0 + 1;
                                break;
                            }
                            case "dislike": {
                                this.works[i].like -= 1;
                                break;
                            }
                            case "collect": {
                                this.works[i].collect = this.works[i].collect - 0 + 1;
                                break;
                            }
                            case "discollect": {
                                this.works[i].collect -= 1;
                                break;
                            }
                        }
                    }
                }
            });
        }
        scroll() {
            this.$store.commit("setState", {
                type: "reportMenu",
                data: false,
            });
        }
        isDialog = false;
        mounted() {
            let urlParmas = new URLSearchParams(location.search.substr(1));
            this.isDialog = !!urlParmas.get("dialog");
            const collect = document.querySelector(".pcview-files-scroll");
            collect.addEventListener("scroll", this.scroll);
            this.$bus.$on("refreshEv", () => {
                this.init();
            });
            if (this.userInfo) {
                if (this.isPC && !this.params.islogin) return;
                this.init();
            } else {
                this.$bus.$on("loginSucc-collect", () => {
                    this.init();
                });
            }
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }
        beforeDestroy() {
            const collect = document.querySelector(".pcview-collect-container");
            collect && collect.removeEventListener("scroll", this.scroll);
            this.$bus.$off("refreshEv");
            this.$bus.$off("loginSucc-collect");
            this.$bus.$off("updateWorkIds2");
            this.$store.commit("setState", { data: false, type: "showLoading" });
            // 关闭举报右键菜单
            this.$store.commit("setState", {
                type: "reportMenu",
                data: false,
            });
        }
    }
</script>

<i18n>
{
  "zh": {
    "title": "我的收藏",
    "name": "名称",
    "search": "搜索模板",
    "notFind": "未找到相关模板",
    "allFiles": "所有收藏",
    "free": "免费",
    "vipFree": "会员免费",
    "like": "已点赞",
    "cancelLike": "已取消点赞",
    "cancelCollect": "已取消收藏",
    "openTips": "文件打开中，请稍后再试",
    "notTem": "这是您的收藏阁，还没有任何收藏哦~"
  },
  "en": {
    "title": "My Favorites",
    "name": "Name",
    "search": "Search template",
    "notFind": "No related template found",
    "allFiles": "All Favorites",
    "free": "Free",
    "vipFree": "VIP Free",
    "like": "Liked",
    "cancelLike": "Remove Likes",
    "cancelCollect": "Remove from Favorites",
    "openTips": "Opening file, please try again later.",
    "notTem": "It is empty, you do not have any favorite!"
  },
  "fr": {
    "title": "Mes favoris",
    "name": "Nom",
    "search": "Modèle de recherche",
    "notFind": "Aucun modèle associé trouvé",
    "allFiles": "Tous favoris",
    "free": "Gratuit",
    "vipFree": "VIP Gratuit",
    "like": "Aimé",
    "cancelLike": "N'a pas aimé",
    "cancelCollect": "Favori annulé",
    "openTips": "Le fichier s'ouvre, veuillez réessayer plus tard",
    "notTem": "Pas encore de favoris ~"
  },
  "de": {
    "title": "Meine Favoriten",
    "name": "Name",
    "search": "Suchen",
    "notFind": "Keine verwandte Vorlage gefunden",
    "allFiles": "Alle Favoriten",
    "free": "Kostenlos",
    "vipFree": "VIP kostenlos",
    "like": "Geliked",
    "cancelLike": "Liked zurücknehmen",
    "cancelCollect": "Von Favoriten entfernen",
    "openTips": "Versuchen Sie die Datei später erneut zu öffnen",
    "notTem": "Noch keine Favoriten~"
  },
  "jp": {
    "title": "お気に入り",
    "name": "名前",
    "search": "テンプレートを検索",
    "notFind": "関連するテンプレートが見つかりません",
    "allFiles": "すべてのお気に入り",
    "free": "無料",
    "vipFree": "メンバーは無料",
    "like": "いいね",
    "cancelLike": "いいねをキャンセル",
    "cancelCollect": "お気に入りの追加をキャンセルしました",
    "openTips": "ファイルを開いています。しばらくしてからもう一度お試しください",
    "notTem": "お気に入りはまだありません"
  },
  "es": {
    "title": "Mis favoritos",
    "name": "Nombre",
    "search": "Buscar plantilla",
    "notFind": "No se encontró ninguna plantilla relacionada.",
    "allFiles": "Todos los favoritos",
    "free": "Gratis",
    "vipFree": "VIP gratis",
    "like": "Me gustó",
    "cancelLike": "Eliminar Me gusta",
    "cancelCollect": "Quitar de favoritos",
    "openTips": "Archivo de apertura, por favor intente nuevamente más tarde.",
    "notTem": "Aquí está tu Colección,¡todavía no hay nada!"
  },
  "pt": {
    "title": "Os Meus Favoritos",
    "name": "Nome",
    "search": "Pesquisar modelo",
    "notFind": "Nenhum modelo relacionado encontrado",
    "allFiles": "Todos os Favoritos",
    "free": "Gratuito",
    "vipFree": "Gratuito VIP",
    "like": "Gosto",
    "cancelLike": "Remover Gostos",
    "cancelCollect": "Remover de Favoritos",
    "openTips": "Abrindo ficheiro, por favor, tentar mais tarde.",
    "notTem": "Está vazio. Não tem nenhum favorito."
  },
  "it": {
    "title": "I Miei Preferiti",
    "name": "Nome",
    "search": "Cerca Modello",
    "notFind": "Nessun modello trovato.",
    "allFiles": "Tutti i Preferiti",
    "free": "Gratis",
    "vipFree": "VIP Gratis",
    "like": "Aggiungi Like",
    "cancelLike": "Rimuovi Like",
    "cancelCollect": "Rimuovi dai Preferiti",
    "openTips": "Apertura file in corso. Si prega di riprovare.",
    "notTem": "Guarda quanto spazio vuoto che c'è! Che ne diresti di ravvivare un po' la situazione?"
  },
  "tw": {
    "title": "我的收藏",
    "name": "名稱",
    "search": "搜索模板",
    "notFind": "未找到相關模板",
    "allFiles": "使用收藏",
    "free": "免費",
    "vipFree": "會員免費",
    "like": "已點讚",
    "cancelLike": "已取消點讚",
    "cancelCollect": "已取消收藏",
    "openTips": "檔案打開中，請稍後再試",
    "notTem": "這是您的收藏閣，還沒有任何收藏哦！"
  },
  "kr": {
    "title": "즐겨찾기",
    "name": "이름",
    "search": "템플릿 찾기",
    "notFind": "관련 템플릿을 찾을 수 없습니다.",
    "allFiles": "모든 즐겨찾기",
    "free": "무료",
    "vipFree": "회원 무료",
    "like": "좋아요 클릭",
    "cancelLike": "좋아요 취소",
    "cancelCollect": "즐겨찾기 취소",
    "openTips": "파일을 여는 중입니다. 나중에 다시 시도하세요.",
    "notTem": "아직 즐겨찾기한 템플릿이 없습니다!"
  },
  "id": {
    "title": "Favorit Saya",
    "name": "Nama",
    "search": "Cari templat",
    "notFind": "Templat terkait tidak ditemukan",
    "allFiles": "Semua Favorit",
    "free": "Gratis",
    "vipFree": "VIP Gratis",
    "like": "Disukai",
    "cancelLike": "Hapus Disukai",
    "cancelCollect": "Hapus dari Favorit",
    "openTips": "Membuka file. Coba lagi nanti.",
    "notTem": "Kosong. Anda tidak memiliki favorit!"
  }
}
</i18n>
